import React from 'react';
import { AuthContainer, AuthPrimaryButton } from '@client/components/AuthComponents';
import { useSignOut } from '@client/components/hooks/use-sign-out';
import { Users, UserCheck, Link, Info, Shield } from 'lucide-react';

export const DuplicateAccountScreen = () => {
  const signOut = useSignOut();

  const handleSignIntoExistingAccount = () => {
    signOut();
  };

  return (
    <AuthContainer title="Account Already Exists">
      <div className="space-y-6 pt-4 text-gray-800">
        <div className="space-y-4 text-center">
          <div className="mb-4 flex justify-center">
            <div className="bg-primary-100 rounded-full p-3">
              <Users className="text-primary h-8 w-8" />
            </div>
          </div>

          <div className="space-y-3">
            <h2 className="text-primary-dark text-lg font-semibold">
              This email is already registered
            </h2>
            <p className="leading-relaxed text-gray-700">
              This email address is already linked to an existing account. Please sign in with your
              existing account to continue.
            </p>
            <p className="text-sm text-gray-700">Account linking is coming soon!</p>
          </div>
        </div>

        <AuthPrimaryButton
          title="Sign Into Existing Account"
          onClick={handleSignIntoExistingAccount}
          className="w-full py-6 text-base"
        />
      </div>
    </AuthContainer>
  );
};
